const budgetOptions = ["Under $3K", "$3K-5K", "$5K – $10K", "$10K+", "Flexible"];
const timelineOptions = ["ASAP", "1–3 months", "3–6 months", "6+ months", "9+ months", "Flexible"];

interface StepBoringStuffProps {
  budget: string;
  timeline: string;
  update: (field: string, value: string) => void;
  isDallasLocal: boolean;
  dallasOfferType: string;
  tradeOffer: string;
  setTradeOffer: (v: string) => void;
}

const StepBoringStuff = ({
  budget,
  timeline,
  update,
  isDallasLocal,
  dallasOfferType,
  tradeOffer,
  setTradeOffer,
}: StepBoringStuffProps) => {
  const showBudget = !isDallasLocal || dallasOfferType === "30% Discount";
  const showTradeOffer = isDallasLocal && dallasOfferType === "Barter / Trade";

  return (
    <div className="flex flex-col gap-6 px-6 py-5">
      <div>
        <p className="font-heading text-ts-lg text-foreground mb-1">
          The boring stuff
        </p>
        <p className="font-body text-ts-xs text-foreground/60">
          Almost there — just a couple quick picks.
        </p>
      </div>

      {showTradeOffer ? (
        <div>
          <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-2 block">
            Trade offer
          </label>
          <p className="font-body text-ts-2xs text-foreground/50 mb-3">
            Tell us what you'd like to trade — e.g. "We run a photography business. Build our site, you get a free 60 min session."
          </p>
          <textarea
            value={tradeOffer}
            onChange={(e) => setTradeOffer(e.target.value)}
            maxLength={500}
            rows={4}
            className="w-full bg-transparent border border-border p-3 font-body text-ts-xs text-foreground placeholder:text-foreground/30 focus:border-primary focus:outline-none transition-colors resize-none"
            placeholder="Describe your trade offer..."
          />
        </div>
      ) : showBudget ? (
        <div>
          <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-2 block">
            Budget range
          </label>
          <div className="flex flex-wrap gap-1.5">
            {budgetOptions.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => update("budget", budget === opt ? "" : opt)}
                className={`px-3 py-1.5 border font-body text-ts-2xs tracking-wide transition-colors ${
                  budget === opt
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-border text-muted-foreground hover:text-foreground hover:border-foreground"
                }`}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      <div>
        <label className="font-body text-ts-2xs font-medium tracking-[0.1em] text-muted-foreground mb-2 block">
          Timeline
        </label>
        <div className="flex flex-wrap gap-1.5">
          {timelineOptions.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => update("timeline", timeline === opt ? "" : opt)}
              className={`px-3 py-1.5 border font-body text-ts-2xs tracking-wide transition-colors ${
                timeline === opt
                  ? "bg-primary text-primary-foreground border-primary"
                  : "border-border text-muted-foreground hover:text-foreground hover:border-foreground"
              }`}
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepBoringStuff;
